import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail, Building2 } from "lucide-react";

export default function Submissions() {
  const [rows, setRows] = useState([]);
  const [kind, setKind] = useState("all");

  useEffect(() => {
    api.get("/submissions").then((r) => setRows(r.data || [])).catch(() => {});
  }, []);

  const filtered = rows.filter((r) => kind === "all" || r.kind === kind);

  return (
    <div>
      <h1 className="font-display font-black text-3xl tracking-tight">Inquiries</h1>
      <p className="text-[#7A7D8C] mt-1 text-sm">Every contact and sponsor form submission lands here.</p>

      <div className="mt-6 flex gap-2 mb-4">
        {[
          { k: "all", label: "All" },
          { k: "contact", label: "Contact" },
          { k: "sponsor", label: "Sponsors" },
        ].map((t) => (
          <button key={t.k} onClick={() => setKind(t.k)} data-testid={`filter-${t.k}`} className={`px-4 py-2 rounded-full text-sm font-semibold border ${kind === t.k ? "bg-[#FF9F1C] text-white border-[#FF9F1C]" : "bg-white border-slate-200"}`}>{t.label}</button>
        ))}
      </div>

      <div className="space-y-3" data-testid="submissions-list">
        {filtered.length === 0 && <div className="bg-white rounded-2xl border border-slate-100 p-12 text-center text-[#7A7D8C]">No submissions yet.</div>}
        {filtered.map((s) => (
          <div key={s.id} className="bg-white rounded-2xl border border-slate-100 p-6">
            <div className="flex items-start justify-between flex-wrap gap-3">
              <div>
                <div className="flex items-center gap-2">
                  <span className={`text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 rounded-full ${s.kind === "sponsor" ? "bg-[#FFBF69]/25 text-[#8A5A17]" : "bg-[#FDE74C]/40 text-[#7A5F00]"}`}>{s.kind}</span>
                  <span className="font-display font-bold text-lg">{s.name}</span>
                </div>
                <div className="mt-1 flex flex-wrap gap-4 text-xs text-[#7A7D8C]">
                  <span className="inline-flex items-center gap-1"><Mail className="w-3 h-3" /> {s.email}</span>
                  {s.organization && <span className="inline-flex items-center gap-1"><Building2 className="w-3 h-3" /> {s.organization}</span>}
                  {s.phone && <span>{s.phone}</span>}
                </div>
              </div>
              <div className="text-xs text-[#7A7D8C]">{new Date(s.created_at).toLocaleString()}</div>
            </div>
            <p className="mt-4 text-sm text-[#1E1E24] whitespace-pre-wrap leading-relaxed">{s.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
